import { render, staticRenderFns } from "./dialogTrusteeshipAdd.vue?vue&type=template&id=0b770159&scoped=true&"
import script from "./dialogTrusteeshipAdd.vue?vue&type=script&lang=js&"
export * from "./dialogTrusteeshipAdd.vue?vue&type=script&lang=js&"
import style0 from "./dialogTrusteeshipAdd.vue?vue&type=style&index=0&id=0b770159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b770159",
  null
  
)

export default component.exports